import React, { useEffect } from 'react';
import styled from 'styled-components';
import Header from '../components/Header';
import PageHeader from '../components/PageHeader';
import HotToursPage from '../components/HotToursPage';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Menu from '../components/Menu';
import SEO from '../components/SEO';

const PageContainer = styled.div`
  background-color: #ededed;
  min-height: 100vh;
`;

const HotTours = () => {
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <SEO 
        title="Горящие туры из Владивостока | Максимум Тур - Лучшие цены"
        description="Горящие туры по минимальным ценам от турагентства Максимум Тур во Владивостоке. Актуальные предложения на путевки по всему миру. Успейте купить тур со скидкой!"
        keywords="горящие туры, горящие путевки, дешевые туры, туры со скидкой, отдых недорого, Максимум Тур, Владивосток"
        type="website"
      />
      <Menu />
      <Header />
      <PageHeader />
      <HotToursPage />
      <ContactForm />
      <Footer />
    </PageContainer>
  );
};

export default HotTours;